import { Period } from '@spike/model';
import clsx from 'clsx';
import OrganizationMarketplacesFilter from 'components/Bookings2/List/OrganizationMarketplacesFilter';
import { CalendarFilter, ClientSelector } from 'components/UI';
import { FunctionComponent, Ref } from 'react';
import ExportCSV from 'components/UI/ExportCSV/ExportCSV';
import styles from './InvoicesFilters.module.scss';

interface InvoicesFiltersProps {
    period: Period;
    clientId: number | null;
    hideClientFilter?: boolean;
    optionSelected: string | undefined;
    selectedMarketplaceIds: Array<number>;
    onChangePeriod: (period: Period, optionSelected: string | undefined) => void;
    onChangeClient: (clientId: number | null) => void;
    onChangeMarketplaceIds: (marketplaceIds: Array<number>) => void;
    className?: string;
    exporting: boolean;
    exportRef: Ref<{ export: () => void }>;
    exportRecords: Array<Array<string>>;
    exportFilename: string;
    onExport: () => void;
}

export const InvoicesFilters: FunctionComponent<InvoicesFiltersProps> = props => {
    const handleChangePeriod = (periodSelected: Period, allTime: boolean, opSelect?: string) => {
        props.onChangePeriod({ ...periodSelected }, opSelect);
    };

    return (
        <div
            className={clsx(styles.container, props.className, {
                [styles.clientScopedContainer]: props.hideClientFilter
            })}
        >
            {!props.hideClientFilter && <ClientSelector onSelectClient={props.onChangeClient} />}
            <div className={styles.buttonsContainer}>
                <OrganizationMarketplacesFilter
                    selected={props.selectedMarketplaceIds}
                    onChangeSelection={props.onChangeMarketplaceIds}
                    className={styles.locationsFilter}
                />
                <CalendarFilter
                    disableFuture
                    hideUpcoming
                    showLabelOnMobile
                    period={props.period}
                    optionSelected={props.optionSelected}
                    className={styles.calendarFilter}
                    onChange={handleChangePeriod}
                />
                <ExportCSV
                    ref={props.exportRef}
                    headers={['Invoice', 'Client', 'Date', 'Total', 'Paid', 'Remaining', 'Status']}
                    records={props.exportRecords}
                    filename={props.exportFilename}
                    exporting={props.exporting}
                    onClick={props.onExport}
                />
            </div>
        </div>
    );
};

export default InvoicesFilters;
